/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getEducationTable = params => {
  return axios.get(`${base}/education`, {params})
}
export const editEducation = params => {
  return axios.post(`${base}/education_update`, params)
}
export const createEducation = params => {
  return axios.post(`${base}/education_create`, params)
}
export const editEducationLevel = params => {
  return axios.post(`${base}/education_priorityLevel`, params)
}
export const uploadFile = params => {
  return axios.post(`${base}/helpcenter_upload_file`, params)
}
export const deleteEducation = id => {
  return axios.post(`${base}/education_delete_` + id)
}
export const getHotTag = id => {
  return axios.get(`${base}/hotsearchlabel_list`)
}
export const getEducation = id => {
  return axios.get(`${base}/education_` + id)
}
export const deleteHotTag = id => {
  return axios.post(`${base}/hotsearchlabel_delete_` + id)
}
export const addHotTag = params => {
  return axios.post(`${base}/hotsearchlabel_create`, params)
}
export const getHomeModuleTable = params => {
  return axios.get(`${base}/appmodule/query`, {params})
}
export const createModule = params => {
  return axios.post(`${base}/appmodule/create`, params)
}
export const editModule = params => {
  return axios.post(`${base}/appmodule/edit_` + params.id, params)
}
export const getAvailableModule = params => {
  return axios.get(`${base}/appmodule/types`)
}
export const getModuleOperateLog = params => {
  return axios.get(`${base}/appmodule/query_log_` + params.id, {params})
}
export const getOrderCommentTable = params => {
  return axios.post(`${base}/query_order_comment`, params)
}
export const getMarketInvalidFeedbackTable = params => {
  return axios.post(`${base}/market-invalid-feedback/query`, params)
}
export const getMarketInvalidFeedbackDetail = feedbackId => {
  return axios.post(`${base}/market-invalid-feedback/detail_${feedbackId}`)
}



// WEBPACK FOOTER //
// ./src/views/platform/platform.api.js